import {REDIRECT_URI_KEY} from 'constants/common'
import {getCurrentUrl} from 'helpers/RouterHelpers'

const PUBLIC_PATHS = [
 '/login',
 '/register',
 '/auth',
 '/thank-you',
 '/reg',
 '/verify-ac-otp-page',
 '/verify-ac-thank-you-page',
 '/privacy-policy',
 '/terms-of-use',
 '/code-of-conduct',
 '/otp-verification',
 '/error',
] as const

export const isPublicPath = (pathname: string): boolean => {
 const path = getCurrentUrl(pathname)
 if (!path || path === '/') {
  return true
 }
 return PUBLIC_PATHS.some(
  (publicPath) =>
   path === publicPath || path.startsWith(`${publicPath}/`)
 )
}

export const isProtectedPath = (
 pathname: string
): boolean => !isPublicPath(pathname)

export const storeRedirectUri = (path: string): void => {
 sessionStorage.setItem(REDIRECT_URI_KEY, path)
}

export const saveReturnUrl = (url: string): void => {
 storeRedirectUri(url)
}

export const getRedirectUri = (): string | null =>
 sessionStorage.getItem(REDIRECT_URI_KEY)

export const clearRedirectUri = (): void => {
 sessionStorage.removeItem(REDIRECT_URI_KEY)
}

const normalizeRoute = (route: string): string => {
 const trimmed = route.trim()
 if (!trimmed) {
  return ''
 }
 return trimmed.startsWith('/') ? trimmed : `/${trimmed}`
}

export const isRouteAllowed = (
 pathname: string,
 allowedRoutes: string[] | undefined
): boolean => {
 if (!allowedRoutes?.length) {
  return false
 }

 const path = getCurrentUrl(pathname)

 return allowedRoutes.some((route) => {
  const normalizedRoute = normalizeRoute(route)
  if (!normalizedRoute) {
   return false
  }
  return (
   path === normalizedRoute ||
   path.startsWith(`${normalizedRoute}/`)
  )
 })
}

export const consumePostLoginRedirect = (
 allowedRoutes: string[] | undefined,
 fallback = '/home-page'
): string | null => {
 const redirectUri = getRedirectUri()
 if (!redirectUri) {
  return null
 }

 clearRedirectUri()

 const normalizedFull = redirectUri.startsWith('/')
  ? redirectUri
  : `/${redirectUri}`
 const pathOnly = getCurrentUrl(normalizedFull)

 if (isRouteAllowed(pathOnly, allowedRoutes)) {
  return normalizedFull
 }

 return fallback
}
